import React from 'react';

type InvestingAccountsProps = {
  selfAccountId: string | undefined;
  accounts: any[];
  transactionTypeId: string;
  handleSetDestinationAccountAndTransactionName: (accountId: string, name: string) => void;
  handleTransactionTypeId: React.Dispatch<React.SetStateAction<string>>;
};

const InvestingAccounts: React.FC<InvestingAccountsProps> = ({
  selfAccountId,
  accounts,
  handleSetDestinationAccountAndTransactionName
}) => { 
  return (
    <div className="relative z-0 w-full mb-5 group">
        <h3 className="mb-2 text-gray-500 text-sm font-sm">Investment accounts</h3>
        <ul className="flex flex-wrap mb-4">
            {accounts
                ?.filter((item) => ( item.Id !== selfAccountId && item.RecordTypeName === 'INVESTMENT'))
                .map((item) => (
                    <li key={item.Id} className="mx-1 my-2">
                        <label htmlFor={item.Id} className="block relative">
                            <input
                                id={item.Id}
                                type="radio"
                                name="investmentSourceAccount"
                                onChange={() => {  handleSetDestinationAccountAndTransactionName(item.Id, item.AccountName)}}
                                className="sr-only peer"
                            />
                            <div className="w-full p-2 cursor-pointer rounded-lg bg-gray-600 shadow-sm ring-white peer-checked:ring-1 duration-200">
                                <h3
                                    className="leading-none text-gray-400 font-medium text-sm" 
                                >
                                    {item.AccountName}
                                </h3>
                            </div>
                        </label>
                    </li>
                ))}
        </ul>
    </div>
  );
};

export default InvestingAccounts;
